

<div class="row main-visor">
<div class="col-12">
  <nb-card>
    <nb-card-header>
      <nav class="navbar navigation">
        <div class="title-filter row">
        <span><nb-icon icon="compass-outline"></nb-icon> Mapas - Visor</span>


      </div>


      </nav>


      <div class="row title-filter">
        <div class="form-group tipo col-2">
          <nb-select multiple placeholder="Tipo de Informe" fullWidth name="role" [(ngModel)]="tipoInformeSeleccionado">
            <nb-option [value]="item.value" *ngFor="let item of tiposInforme">{{item.title}}</nb-option>
          </nb-select>
        </div>
        <div class="form-group tipo col-2" *ngIf="null !=tipoInformeSeleccionado && tipoInformeSeleccionado.includes('sampling')">
          <angular2-multiselect [data]="listaMuestreos"
            [(ngModel)]="muestreoSeleccionado"
            [settings]="settings">
          </angular2-multiselect>
        </div>
        <span class="space-left">Fechas</span>
        <div class="form-group space-left">
          <input nbInput [nbDatepicker]="rangepicker" [(ngModel)]="fechasFiltro">
<nb-rangepicker #rangepicker format="dd/MM/yyyy"> </nb-rangepicker>
        </div>

        <button class="space-left" nbButton status="primary" shape="round" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
        </button>
      </div>




      <div class="row title-filter">


        <button class="space-left" nbButton shape="round" status="info" (click)="aplicar()"><nb-icon icon="search-outline"></nb-icon>
          Buscar </button>
          <button class="space-left" nbButton shape="round" status="success" (click)="limpiar()"><nb-icon icon="sync-outline"></nb-icon>
          Limpiar </button>
          <button class="space-left" nbButton shape="round" status="primary" (click)="exportar()"><nb-icon icon="cloud-download-outline"></nb-icon>
            Exportar </button>
      </div>

    </nb-card-header>

    <nb-card-body>
      <div class="row mapa" [nbSpinner]="loading"
      nbSpinnerStatus="danger"
      nbSpinnerSize="large"
      nbSpinnerMessage="Cargando informes...">
        <div class="panel-body map-container" [attr.id]="config.target" ></div>
        <div id="popup" *ngIf="informeSeleccionado != null" [hidden]="informeSeleccionado == null">
            <nb-card>
              <nb-card-header>
                <nav class="navbar navigation">
                  <h3>{{informeSeleccionado.titulo}}</h3>
                  <button nbButton status="primary" (click)="closeReport()"><nb-icon icon="close-outline"></nb-icon>
                  </button>
                </nav>
              </nb-card-header>
              <nb-card-body>
                  <ngx-disease-lite *ngIf="informeSeleccionado.tipo == 'disease'" [loadReport]="informeSeleccionado"></ngx-disease-lite>
                  <ngx-maintenance-lite *ngIf="informeSeleccionado.tipo == 'maintenance'" [loadReport]="informeSeleccionado"></ngx-maintenance-lite>
                  <ngx-sampling-lite *ngIf="informeSeleccionado.tipo == 'sampling'" [loadReport]="informeSeleccionado"></ngx-sampling-lite>

                </nb-card-body>

            </nb-card>

        </div>

        <div id="popup" *ngIf="parcelaSeleccionada != null" [hidden]="parcelaSeleccionada == null">
          <nb-card>
            <nb-card-header>
              <nav class="navbar navigation">
                <h3>Parcela</h3>
                <button nbButton status="primary" (click)="closeReport()"><nb-icon icon="close-outline"></nb-icon>
                </button>
              </nav>

            </nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="nombreparcela" class="label">Nombre</label>
                    <input type="text" nbInput fullWidth id="nombreparcela" readonly="true" name="nombreparcela" [(ngModel)]="parcelaSeleccionada.name" >
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="region" class="label">Region</label>
                    <input type="text" nbInput fullWidth id="region" readonly="true" name="region" [(ngModel)]="parcelaSeleccionada.region" >
                  </div>
                </div>
              </div>

              </nb-card-body>

          </nb-card>

      </div>

      </div>





    </nb-card-body>
  </nb-card>
</div>



</div>



